<template>
  <button
    v-bind="$attrs"
    data-inheritattrs
    class="nortic-button"
    :class="classes"
    :style="{ fontSize }"
    @click="emitClickEvent"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <slot>
      <SvgIcon
        v-if="icon"
        :data="icon"
      />
    </slot>
  </button>
</template>

<script>
import colorHandler from '@/mixins/themeSupport';
import button from '@/components/common/button/mixin/button';

export default {
  name: 'NorticIconButton',
  mixins: [colorHandler(), button],
  inheritAttrs: false,
  props: {
    icon: {
      type: [String, Object],
      default: null,
    },
    fontSize: {
      type: String,
      default: '1em',
    },
  },
  methods: {
    emitClickEvent(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/components/common/button/mixin/sass/button.scss';

  .nortic-button {
    @include applyButtonStyles(1);
  }
</style>
